import React from 'react';
import PropTypes from 'prop-types';
import PriceButton from '../price/PriceButton';
import RaceCardLink from '../links/RaceCardLink';
import { formatEntryDateTime } from '../../utils/date';
import { yardsToFurlongs } from '../../utils/distance';
import EntriesHorseLink from './EntriesHorseLink';

const raceStatus = {
    O: 'Overnight',
    C: 'Early closer',
    3: 'Three day',
    4: 'Four day',
    5: 'Five day',
    6: 'Six day',
};

const EntriesRow = ({ data, isHorseShown, isDamShown, isPriceShown }) => {
    const {
        courseStyleName,
        courseUid,
        raceDatetime,
        raceInstanceTitle,
        raceInstanceUid,
        raceStatusCode,
        raceUid,
        runningConditions,
        distanceYard,
    } = data;
    return (
        <li className="pp-entries__item">
            <div className="pp-entries__item__wrapper">
                <div className="pp-entries__item__header">
                    <span>{formatEntryDateTime(raceDatetime)} </span>
                    {isHorseShown && <EntriesHorseLink
                        {...data}
                        isDamShown={isDamShown}
                    />}
                </div>
                {raceStatusCode && `(${raceStatus[raceStatusCode]}) `}
                {courseStyleName && `at ${courseStyleName} `}
                <RaceCardLink
                    courseName={courseStyleName}
                    courseUid={courseUid}
                    raceDatetime={raceDatetime}
                    raceInstanceUid={raceInstanceUid || raceUid}
                >
                    {raceInstanceTitle}
                </RaceCardLink>
                {runningConditions && ` (${runningConditions})`}
                {distanceYard && ` (${yardsToFurlongs(distanceYard)})`}
            </div>
            {isPriceShown && <PriceButton {...data} />}
        </li>
    );
};


EntriesRow.propTypes = {
    data: PropTypes.shape({
        courseStyleName: PropTypes.string,
        courseUid: PropTypes.number,
        raceDatetime: PropTypes.string,
        raceInstanceTitle: PropTypes.string,
        raceInstanceUid: PropTypes.number,
        raceStatusCode: PropTypes.string,
        raceUid: PropTypes.number,
        distanceYard: PropTypes.number,
    }).isRequired,
    isDamShown: PropTypes.bool,
    isPriceShown: PropTypes.bool,
    isHorseShown: PropTypes.bool,
};

export default EntriesRow;



// WEBPACK FOOTER //
// ./src/js/shared/entries/EntriesRow.jsx